<template>
  <div id="app" :class="{ news: this.$route.name === 'home' }">
    <navigation></navigation>
    <transition name="page" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
const Navigation = () =>
  import(/* webpackChunkName: "Navigation" */ "@/components/Navigation.vue");
export default {
  name: "App",
  metaInfo() {
    return {
      title: "Global Context",
      titleTemplate: "Global Context" + " %s"
    };
  },
  components: {
    Navigation
  },
  computed: mapState(["site"]),
  beforeCreate() {
    this.$store.dispatch("loadSite");
    // this.$store.dispatch("loadTeaching");
    // this.$store.dispatch("loadVisiting");
  }
};
</script>

<style lang="scss">
@import "node_modules/reset-css/sass/_reset";
@font-face {
  font-family: "BM";
  src: url("./assets/fonts/Basel-Medium.otf") format("opentype");
}
@font-face {
  font-family: "BB";
  src: url("./assets/fonts/Basel-Bold.woff") format("woff");
}
@font-face {
  font-family: "BI";
  src: url("./assets/fonts/Basel-BookItalic.woff") format("woff");
}
* {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
em {
  font-family: "BI", sans-serif;
}
:root {
  --fs: 0.98rem;
  --lh: calc(1.25 * 0.98rem);
  --color: rgb(0, 0, 0);
  --hover: rgb(150, 150, 150);
  @media only screen and (max-width: 768px) {
    --fs: 0.95rem;
    --lh: calc(1.25 * 0.95rem);
  }
  @media only print {
    --fs: 0.9rem;
    --lh: calc(1.25 * 0.9rem);
  }
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.7s;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
p {
  margin-bottom: var(--lh);
  &:last-of-type {
    margin-bottom: 0;
  }
}
.subm {
  @media only screen and (max-width: 768px) {
    margin-top: calc((2 * var(--lh)) + (4 * var(--fs))) !important;
  }
}
h1 {
  font-size: calc(2 * var(--fs));
  line-height: 1;
  text-transform: uppercase;
}

.grey {
  color: var(--hover);
}
strong {
  font-family: "BB", sans-serif;
  font-weight: normal;
}
.uc {
  text-transform: uppercase;
}
.p {
  padding: calc(0.5 * var(--lh));
}
.p-h {
  padding: 0 calc(0.5 * var(--lh));
}
.ph {
  padding: calc(0.25 * var(--lh));
}
.pt {
  padding-top: calc(0.5 * var(--lh));
}
.pht {
  padding-top: calc(0.2 * var(--lh));
}
.pv {
  padding: calc(0.5 * var(--lh)) 0;
}
.pl {
  padding-left: calc(0.5 * var(--lh));
}
.phl {
  padding-left: calc(0.25 * var(--lh));
}
.pr {
  padding-right: calc(0.5 * var(--lh));
}
.pb {
  padding-bottom: calc(0.5 * var(--lh));
}
.br {
  border-right: 1px solid black;
}
.bl {
  border-left: 1px solid black;
  &.no-mobile {
    @media only screen and (max-width: 768px) {
      border-left: 0;
    }
  }
}
.bt {
  border-top: 1px solid black;
}
.bb {
  border-bottom: 1px solid black;
}
.gt {
  display: grid;
  grid-template-columns: 200px 1fr;
  grid-gap: calc(0.5 * var(--lh));
  @media only screen and (max-width: 768px) {
    grid-template-columns: 90px 1fr;
  }
}

img {
  width: 100%;
  display: block;
  &.arrow {
    display: inline-block;
    height: calc(0.7 * var(--fs));
    width: auto;
    &.down {
      transform: rotate(180deg);
    }
  }
}
.fl::first-letter {
  text-transform: capitalize;
}

a,
a:active,
a:hover,
a:visited,
.link {
  color: var(--hover);
  cursor: pointer;
  text-decoration: none;
  user-select: none;
  img.arrow {
    opacity: 0.5;
  }
  &.router-link-active,
  &.black {
    color: var(--color);
  }
  &:hover {
    img.arrow {
      opacity: 1;
    }
    color: var(--color);
  }
}

body,
html {
  width: 100%;
  // height: 100%;
  font-size: var(--fs);
  line-height: var(--lh);
}
@media print {
  @page {
    margin: 0;
  }
  body {
    padding: calc(2 * var(--lh));
  }
}

.no-mobile {
  @media only screen and (max-width: 768px) {
    display: none;
  }
}

.submenu {
  @media only screen and (min-width: 768px) {
    display: none;
  }
  a {
    display: block;
  }
}

#app {
  width: 100%;
  height: 100%;
  // min-height: 100%;
  overflow-x: hidden;
  font-family: "BM", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;

  // overflow-y: auto;
  @media only print {
    display: block;
    overflow: auto;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
  nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 350px;
    height: 100%;
    overflow-y: auto;
    z-index: 2;
    background: white;
    padding: calc(0.5 * var(--lh));
    border-right: 1px solid var(--color);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    @media only screen and (max-width: 768px) {
      position: fixed;
      width: 100%;
      background: white;
      border-right: 0;
      flex: 0 0 auto;
      height: auto;
      border-bottom: 1px solid var(--color);
    }
    @media only print {
      width: 100%;
      position: relative;
      top: auto;
      left: auto;
      border-right: 0;
      border-bottom: 1px solid var(--color);
      height: auto;
    }
  }
  .filler {
    flex: 1 0 auto;
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, calc(33% + 3px));
    grid-auto-rows: auto;
    overflow: hidden;
    @media only screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
    > div {
      height: 100%;
      @media only screen and (max-width: 768px) {
        height: 0 !important;
        border-right: 0px !important;
      }
    }
  }
  main {
    min-height: 100vh;
    width: 100%;
    @media only screen and (max-width: 768px) {
      height: auto;
      min-height: auto;
      &.home {
        min-height: auto;
      }
      margin-top: calc(2 * var(--fs) + 1 * var(--lh));
    }
    .news {
      padding-left: 350px;
      display: flex;
      min-height: 100%;
      @media only screen and (max-width: 768px) {
        padding-left: 0;
        min-height: 100vh;
      }
      @media only print {
        padding-left: 0;
      }
      &.mobile {
        overflow-x: auto;
        .col {
          @media only screen and (max-width: 768px) {
            flex: 0 0 calc(80vw + 2px);
            display: block;
          }
          &.active {
            @media only screen and (max-width: 768px) {
              flex: 0 0 calc(80vw + 2px);
              display: block;
            }
          }
        }
      }
      .col {
        display: inline-block;
        transition: all 750ms ease;
        vertical-align: top;
        min-height: 100%;
        flex: 0 0 calc((100vw - 350px) / 3);
        overflow-x: hidden;
        &.scroll {
          height: 100vh;
          overflow-y: auto;
          @media only screen and (max-width: 768px) {
            height: auto;
          }
        }
        &.fw {
          flex: 0 0 100%;
          display: flex;
          flex-direction: column;
        }
        @media only print {
          flex: 0 0 calc(100% / 3);
        }
        @media only screen and (max-width: 768px) {
          flex: 0 0 calc(100vw + 2px);
        }
        &.news-col {
          @media only screen and (max-width: 768px) {
            position: absolute;
            top: calc(2.5 * var(--lh));
            left: 0;
            width: 100%;
            opacity: 0;
            pointer-events: none;
            &.active {
              opacity: 1;
              pointer-events: auto;
            }
          }
        }
        &.active {
          flex: 0 0 calc((100vw - 350px) * (2 / 3));
          @media only print {
            flex: 0 0 calc(100% * (2 / 3));
          }
          @media only screen and (max-width: 768px) {
            flex: 0 0 calc(100vw + 2px);
          }
        }
        &.left {
          cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='20px' height='16.39px' viewBox='0 0 20 16.39' style='enable-background:new 0 0 20 16.39;' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cg%3E%3Cpath d='M0,7.14h16.13L9.28,0h2.9L20,8.2l-7.82,8.19h-2.9l6.85-7.16H0V7.14z'/%3E%3C/g%3E%3C/svg%3E%0A"),
            e-resize;
          .news-item {
            cursor: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' width='20px' height='16.39px' viewBox='0 0 20 16.39' style='enable-background:new 0 0 20 16.39;' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cg%3E%3Cpath d='M0,7.14h16.13L9.28,0h2.9L20,8.2l-7.82,8.19h-2.9l6.85-7.16H0V7.14z'/%3E%3C/g%3E%3C/svg%3E%0A"),
              e-resize;
          }
        }
        &.right {
          cursor: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='20px' height='16.39px' viewBox='0 0 20 16.39' style='enable-background:new 0 0 20 16.39;' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cg%3E%3Cpath d='M20,9.25H3.87l6.84,7.14h-2.9L0,8.19L7.82,0h2.9L3.86,7.16H20V9.25z'/%3E%3C/g%3E%3C/svg%3E"),
            w-resize;
          .news-item {
            cursor: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='20px' height='16.39px' viewBox='0 0 20 16.39' style='enable-background:new 0 0 20 16.39;' xml:space='preserve'%3E%3Cdefs%3E%3C/defs%3E%3Cg%3E%3Cpath d='M20,9.25H3.87l6.84,7.14h-2.9L0,8.19L7.82,0h2.9L3.86,7.16H20V9.25z'/%3E%3C/g%3E%3C/svg%3E"),
              w-resize;
          }
        }
        &.active {
          &.left {
            .news-col {
              // width: calc((100vw - 350px) / 3 + 0.5px);
            }
          }
          &.left,
          &.right {
            .news-item {
              cursor: pointer;
            }
            cursor: default;
          }
        }
      }
    }
    .three {
      padding-left: 350px;
      height: 100%;
      display: grid;
      grid-template-columns: minmax(0, auto) minmax(0, 2fr) minmax(
          0,
          calc(33% + 3px)
        );
      @media only screen and (max-width: 768px) {
        // grid-template-columns: minmax(0, auto) minmax(0, 1fr) minmax(0, 0);
        padding-left: 0;
      }
      @media only print {
        grid-template-columns: minmax(0, 2fr) minmax(0, calc(33% + 3px));
        padding-left: 0;
      }
      .c2 {
        display: flex;
        flex-direction: column;
        grid-column: span 2;
      }
    }
    .full {
      min-height: 100%;
      display: grid;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
      transform: translate3d(350px, 0, 0);
      transition: transform 0.7s;
      &.three {
        grid-template-columns: 1fr 1fr 1fr;
      }
      @media only screen and (max-width: 768px) {
        transform: translate3d(0, 0, 0);
        grid-template-columns: 3fr 1fr;
        min-height: 100vh;
      }
      &.inverse {
        transform: translate3d(0, 0, 0);
        @media only screen and (max-width: 768px) {
          transform: translate3d(-20%, 0, 0);
        }
      }
      .col {
        &.left {
          cursor: e-resize;
          .news-item {
            cursor: e-resize;
          }
        }
        &.right {
          cursor: w-resize;
          .news-item {
            cursor: w-resize;
          }
        }
        &.active {
          // pointer-events: default;
          &.left,
          &.right {
            .news-item {
              cursor: pointer;
            }
            cursor: default;
          }
        }
      }
    }
  }
  footer {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3;
    width: 350px;
    padding: calc(0.5 * var(--lh));
    @media only print {
      display: none;
    }
    @media only screen and (max-width: 768px) {
      width: 100%;
      background: white;
      border-top: 1px solid black;
    }
  }
}
</style>
